export default [
  {
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: 'PageFaq' */ '../PageFaq.vue'),
    meta: {
      store: ['page/getPageData'],
    },
    children: [
      {
        path: ':sectionSlug',
        name: 'faq-section',
        children: [
          {
            path: ':itemSlug',
            name: 'faq-item',
          },
        ],
      },
    ],
  },
];
